import constants from "../utils/Constants";
import { getData, postData, putData } from "./rest-api-helper"


export async function getComDashServ({ userType, limit, pageNumber, searchKeyWord, projIdStrg }) {
    let urlPath;

    if (userType === constants.lineManager)
        urlPath = `/dashboard/lineManager`;
    else if (userType === constants.focalPoint)
        urlPath = `/dashboard/cfp`;
    else if (userType === constants.approver)
        urlPath = `/dashboard/approver`;
    else if (userType === constants.admin)
        urlPath = `/dashboard/admin`;
    else if (userType === constants.sourcing)
        urlPath = `/dashboard/source`;
    else if (userType === constants.store)
        urlPath = `/dashboard/store`;
    else
        urlPath = `/dashboard/requestor`;

    const details = {
        urlPath: urlPath,
        queryParams: {
            ...(searchKeyWord && { searchWord: searchKeyWord }),
            ...(limit && { limit }),
            ...(pageNumber && { offset: (pageNumber * limit) - limit }),
            ...(projIdStrg && { projIdStrg })
        }
    }
    const res = await getData(details);
    return res.data;
}

export async function getComUserProfile() {
    const details = {
        urlPath: `/company/user/myProfile`
    }
    const res = await getData(details);
    return res.data;
}

export async function getNavData(userId, isComUser) {
    const comDet = {
        urlPath: `/company/user/myProfile`
    }
    const amtcDet = {
        urlPath: `/amtc/userProfile`,
        queryParams: {
            userId
        }
    }
    const res = await getData(isComUser ? comDet : amtcDet);
    return res.data;
}

export async function getAmtcUserProfile(userId) {
    const details = {
        urlPath: `/amtc/userProfile`,
        queryParams: {
            userId
        }
    }
    const res = await getData(details);
    return res.data;
}

export async function getAmtcCat({ limit, pageNumber, order }) {
    const details = {
        urlPath: "/amtc/categories",
        queryParams: {
            ...(limit && { limit }),
            ...(pageNumber && { offset: (pageNumber * limit) - limit }),
            ...(order && { sort: order }),
        }
    }
    const res = await getData(details);
    return res.data;
}

export async function getAmtcSubCat({ catId, limit, pageNumber, order }) {

    const details = {
        urlPath: "/amtc/subCat",
        queryParams: {
            catId,
            ...(limit && { limit }),
            ...(pageNumber && { offset: (pageNumber * limit) - limit }),
            ...(order && { sort: order }),
        }
    }
    const res = await getData(details);
    return res.data;
}

export async function getAmtcProd({ catId, subCatId, limit, pageNumber, searchKeyWord, order, isApproved = 11 }) {
    if (searchKeyWord) {
        catId = undefined; subCatId = undefined;
    }
    const details = {
        urlPath: "/amtc/product",
        queryParams: {
            ...(catId && { catId }),
            ...(subCatId && { subCatId }),
            ...(searchKeyWord && { searchWord: searchKeyWord }),
            ...(limit && { limit }),
            ...(pageNumber && { offset: (pageNumber * limit) - limit }),
            ...(order && { sort: order }),
            ...(isApproved && { isApproved: 0 }),
        }
    }
    const res = await getData(details);
    return res.data;
}

export async function createCatServ(data) {
    const details = {
        urlPath: "/amtc/category",
        body: {
            ...data
        }
    }
    const res = await postData(details);
    return res;
}


export async function editCatServ(data, catId) {
    const details = {
        urlPath: `/amtc/editCategory/${catId}`,
        body: {
            ...data
        }
    }
    const res = await putData(details);
    return res;
}

export async function getSingleCatServ(catId) {
    const details = {
        urlPath: `/amtc/categories/single/${catId}`
    }
    const res = await getData(details);
    return res.data;
}

export async function createSubCatServ(data) {
    const details = {
        urlPath: "/amtc/subCat",
        body: {
            ...data
        }
    }
    const res = await postData(details);
    return res;
}


export async function editSubCatServ(data, catId) {
    const details = {
        urlPath: `/amtc/editSubCat/${catId}`,
        body: {
            ...data
        }
    }
    const res = await putData(details);
    return res;
}


export async function createProdServ(data) {
    const details = {
        urlPath: "/amtc/product",
        body: {
            ...data
        }
    }
    const res = await postData(details);
    return res;
}

export async function getSingleProdServ(amtcProdIdStrg, type, comId,) {
    if (type === "amtc" || type === "req" || type === "created") {
        const details = {
            urlPath: `/amtc/product/single/${amtcProdIdStrg}`
        }
        const res = await getData(details);
        return res.data;
    } else {
        const details = {
            urlPath: `/amtc/getSingleComProd`,
            queryParams: {
                comId, amtcProdIdStrg
            }
        }
        const res = await getData(details);
        return res.data;
    }

}


export async function editProductServ(data, amtcProdIdStrg) {
    const details = {
        urlPath: `/amtc/editProduct/${amtcProdIdStrg}`,
        body: {
            ...data
        }
    }
    const res = await putData(details);
    return res;
}

export async function updateProdStock(data, amtcProdIdStrg) {
    const details = {
        urlPath: `/amtc/product/updateStockDetails/${amtcProdIdStrg}`,
        body: {
            ...data
        }
    }
    const res = await putData(details);
    return res;
}

export async function getApprProdsServ({ limit, pageNumber, searchKeyWord, searchKeyType, order, type }) {
    const details = {
        urlPath: "/amtc/getApprProds",
        queryParams: {
            ...(searchKeyWord && { searchWord: searchKeyWord }),
            ...(searchKeyType && { searchType: searchKeyType }),
            ...(limit && { limit }),
            ...(pageNumber && { offset: (pageNumber * limit) - limit }),
            ...(order && { sort: order }),
            ...(type && { type }), // created / req
        }
    }
    const res = await getData(details);
    return res.data;
}

export async function putProdApprServ(amtcProdIdStrg, status, rjcRemarks) {
    const details = {
        urlPath: `/amtc/putProdAppr/${amtcProdIdStrg}`,
        body: {
            status, rjcRemarks
        }
    }
    const res = await putData(details);
    return res;
}

export async function editProdAllInfoServ(data) {
    const details = {
        urlPath: `/amtc/editProdAllInfo`,
        body: {
            ...data
        }
    }
    const res = await putData(details);
    return res;
}


export async function getProdStockListServ(amtcProdIdStrg) {
    const details = {
        urlPath: `/amtc/comProdStock`,
        queryParams: {
            amtcProdIdStrg
        }
    }
    const res = await getData(details);
    return res.data;
}

export async function getAmtcEmpListServ({ limit, pageNumber, searchWord, order, userType, status }) {
    const details = {
        urlPath: "/amtc/users",
        queryParams: {
            ...(searchWord && { searchWord }),
            ...(limit && { limit }),
            ...(pageNumber && { offset: (pageNumber * limit) - limit }),
            ...(order && { sort: order }),
            ...(userType && { userType }),
            ...(status && { status }),
        }
    }
    const res = await getData(details);
    return res.data;
}

export async function createAmtcEmpServ(data) {
    const details = {
        urlPath: "/amtc/createUser",
        body: {
            ...data
        }
    }
    const res = await postData(details);
    return res;
}

export async function getSingleAmtcUserServ(userId) {
    const details = {
        urlPath: "/amtc/userProfile",
        queryParams: {
            userId
        }
    }
    const res = await getData(details);
    return res.data;
}

export async function editAmtcUser(data, userId) {
    const details = {
        urlPath: `/amtc/editUser/${userId}`,
        body: {
            ...data
        }
    }
    const res = await putData(details);
    return res;
}

export async function deleteProdServ({ amtcProdIdStrg, status }) {
    const details = {
        urlPath: `/amtc/deleteProduct`,
        body: {
            amtcProdIdStrg, status
        }
    }
    const res = await putData(details);
    return res;
}

export async function getDeletedProdsServ({ limit, pageNumber, searchWord, searchType, order }) {
    const details = {
        urlPath: "/amtc/getDeletedProds",
        queryParams: {
            ...(searchWord && { searchWord }),
            ...(searchType && { searchType }),
            ...(limit && { limit }),
            ...(pageNumber && { offset: (pageNumber * limit) - limit }),
            ...(order && { sort: order })
        }
    }
    const res = await getData(details);
    return res.data;
}

export async function updateEmpStatusServ({ userId, status, isComUser }) {
    const details = {
        urlPath: `/amtc/updateEmpStatus`,
        body: {
            userId, status, isComUser
        }
    }
    const res = await putData(details);
    return res;
}

export async function updateUsernameServ(payload) {
    const details = {
        urlPath: `/amtc/updateUsername`,
        body: {
            ...payload
        }
    }
    const res = await putData(details);
    return res;
}